import Konva from "konva";

/**
 *
 * @param layer
 */
export function initTabletMaskLayer(layer, w, h) {
  // Imageを左右に置く
  let shape = new Konva.Rect({
    x: 0,
    y: 0,
    width: 1298,
    height: 1080,
    fill: '#141414',
  });
  layer.add(shape);
  let shape2 = new Konva.Rect({
    x: 2544,
    y: 0,
    width: 1276,
    height: 1080,
    fill: '#141414',
  });
  layer.add(shape2);
}

/**
 * タブレットの画像保存するときのマスクされた画像を返す
 */
export function drawMaskedImage(canvas, x, y, width, height) {
  const resizedCanvas = document.createElement("canvas");
  const resizedContext = resizedCanvas.getContext("2d");
  resizedCanvas.height = height;
  resizedCanvas.width = width;
  resizedContext.drawImage(canvas, x, y, width, height, 0, 0, width, height);
  return resizedCanvas.toDataURL("image/png");
}
